import React from "react";
import "./Logout.css";

const Lgout = () => {
  const logout = () => {
    try {
      localStorage.removeItem("token");
      window.location = "/";
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="logout">
      {/* <div className="logout__img--container">
        <img src={logout_img} className="logout__img" alt="logout" />
      </div> */}
      <div className="logout__box">
        <button className="btn btn-logout" onClick={logout}>
          Logout
        </button>
        <button
          className="btn btn-cancel"
          onClick={() => (window.location = "/")}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default Lgout;
